import React from 'react';
import { ClassAssembly9C2026 } from '../views';

const ClassAssemblyPage = () => {
    return <ClassAssembly9C2026/>;
  };
  
  export default ClassAssemblyPage;